import log from 'loglevel'
import { healthCheckFunction } from '../configuration/interface'

const pollIntervalMs = 2000
const maxAttempts = 15

// Polls the app on the remote machine until it responds with http status 200,
// checking every 2s for up to 30s total
export const healthCheck: healthCheckFunction = async (ssh, port) => {
  log.info('start healthCheck')

  // Calls localhost with specified port on the remote machine and checks if respond http status is 200
  const command = `curl -I -s -o /dev/null -L -w "%{http_code}" http://localhost:${port} | grep 200`

  let lastResult
  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    await sleep(pollIntervalMs)
    lastResult = await ssh.execCommand(command)
    log.debug('Executing command:', command, lastResult)

    if (!lastResult.code || lastResult.code === 0) {
      if (lastResult.stderr) {
        log.warn(lastResult.stderr)
      }
      log.info('finished healthCheck')
      return
    }
    log.info(`Health check attempt ${attempt}/${maxAttempts} failed, retrying in ${pollIntervalMs / 1000}s`)
  }

  if (lastResult && lastResult.stderr) {
    log.error(lastResult.stderr)
  }
  throw new Error('HEALTH CHECK FAILED')
}

// UTIL
function sleep(ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}
